import React from 'react';

import * as _ht from './_ht';
import * as _cr from './_cr';

import * as icv from './icv';

import * as _gv from './_gv';
import * as _cmSCL from './_cmSCL';

const $dsnz = {
  dwrW: 25,
  mainHdrH: 6,
  mainFtnH: 6,
  pageHdrH: 5,
};

export const w = (
  tgt: 'page' | 'dwr' | 'main', 
  cmn?: _ht.n // column
) => {

  const _gDsnz = _gv.useDsnz();

  const _cmn = cmn ?? 0;

  const _pageW = _gDsnz.crt.pageW;
  if ( tgt == 'page' ) {
    return (_cmn > 0) ? (( _pageW - _cmSCL.s(_cmn + 1) ) / _cmn) : _pageW;
  }

  const _dwrW = _cmSCL.s(icv.dsnz?.dwrW ?? $dsnz.dwrW);
  if ( tgt == 'dwr' ) {
    return (_cmn > 0) ? (( _dwrW - _cmSCL.s(_cmn + 1) ) / _cmn) : _dwrW;
  }

  const _mainW = _pageW - _dwrW;
  if ( tgt == 'main' ) {
    return (_cmn > 0) ? (( _mainW - _cmSCL.s(_cmn + 1) ) / _cmn) : _mainW;
  }

  return 0;
};

export const h = (
  tgt: 'page' | 'pageHdr' | 'main' | 'mainHdr' | 'mainFtn' | 'mainBdy',
  cmn?: _ht.n
): _ht.n => {

  const _gDsnz = _gv.useDsnz();

  const _cmn = cmn ?? 0;

  const _pageH = _gDsnz.crt.pageH;
  if ( tgt == 'page' ) {
    return (_cmn > 0) ? (( _pageH - _cmSCL.s(_cmn + 1) ) / _cmn) : _pageH;
  }

  const _pageHdrH = _cmSCL.s((icv.dsnz?.pageHdrH ?? $dsnz.pageHdrH) + (_cr.o('i') ? _cmSCL.s(3) : 0));
  if ( tgt == 'pageHdr' ) {
    return (_cmn > 0) ? (( _pageHdrH - _cmSCL.s(_cmn + 1) ) / _cmn) : _pageHdrH;
  }

  const _mainH = _pageH - _pageHdrH;
  if ( tgt == 'main' ) {
    return (_cmn > 0) ? (( _mainH - _cmSCL.s(_cmn + 1) ) / _cmn) : _mainH;
  }

  const _mainHdrH = _cmSCL.s(icv.dsnz?.mainHdrH ?? $dsnz.mainHdrH);
  if ( tgt == 'mainHdr' ) {
    return (_cmn > 0) ? (( _mainHdrH - _cmSCL.s(_cmn + 1) ) / _cmn) : _mainHdrH;
  }

  const _mainFtnH = _cmSCL.s(icv.dsnz?.mainFtnH ?? $dsnz.mainFtnH);
  if ( tgt == 'mainFtn' ) {
    return (_cmn > 0) ? (( _mainFtnH - _cmSCL.s(_cmn + 1) ) / _cmn) : _mainFtnH;
  }

  const _mainBdyH = _mainH - _mainHdrH;
  if ( tgt == 'mainBdy' ) {
    return (_cmn > 0) ? (( _mainBdyH - _cmSCL.s(_cmn + 1) ) / _cmn) : _mainBdyH;
  }
  return 0;
};
